import React, { useRef, useState } from "react";
import { Check, Copy, Share2, X } from "lucide-react";
import { trackPodcastAction } from "./podcastAnalytics";
import "./PodcastShareDialog.css";

export default function PodcastShareDialog({ url, builderId, runId, onClose }) {
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState("");
  const linkInputRef = useRef(null);
  const canUseNativeShare = typeof navigator !== "undefined" && typeof navigator.share === "function";

  const copyLink = async () => {
    trackPodcastAction("share_copy", { builderId, runId, source: "builder" });
    setError("");
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        linkInputRef.current?.select();
        if (!document.execCommand("copy")) throw new Error("Copy was not available.");
      }
      setCopied(true);
    } catch (copyError) {
      linkInputRef.current?.select();
      setError("Could not copy automatically. Select and copy the link above.");
    }
  };

  const shareLink = async () => {
    setError("");
    try {
      await navigator.share({ title: "My Podcast", url });
      trackPodcastAction("share_native", { builderId, runId, source: "builder" });
    } catch (shareError) {
      if (shareError?.name !== "AbortError") setError("Could not open sharing. You can copy the link instead.");
    }
  };

  return <div className="mb-podcastShareBackdrop" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <div className="mb-podcastShareDialog" role="dialog" aria-modal="true" aria-labelledby="mb-podcast-share-title" onKeyDown={(event) => { if (event.key === "Escape") onClose(); }}>
      <button className="mb-podcastShareClose" type="button" onClick={onClose} aria-label="Close share dialog"><X size={18} /></button>
      <div className="mb-podcastShareHeading">
        <div className="mb-podcastShareIcon"><Share2 size={22} /></div>
        <h2 id="mb-podcast-share-title">Share My Podcast</h2>
      </div>
      <div className="mb-podcastShareLinkRow">
        <input id="mb-podcast-share-link" ref={linkInputRef} value={url} readOnly aria-label="Podcast listening page link" onFocus={(event) => event.target.select()} />
        <button type="button" onClick={copyLink} autoFocus aria-label={copied ? "Link copied" : "Copy link"} title={copied ? "Copied" : "Copy link"}>{copied ? <Check size={18} /> : <Copy size={18} />}</button>
        {canUseNativeShare && <button type="button" onClick={shareLink} aria-label="Share link" title="Share link"><Share2 size={18} /></button>}
      </div>
      {error && <p className="mb-podcastShareError" role="alert">{error}</p>}
    </div>
  </div>;
}
